/**
 * CallFlow Detail Page
 *
 * Dedicated page for viewing and managing a single CallFlow.
 * Accessible via /callflows/:id route.
 */

import { useParams, useNavigate } from 'react-router-dom';
import DashboardLayout from '../dashboard/layout/DashboardLayout';
import { CallFlowDetail } from '../callflow/CallFlowDetail';
import { useOrganization } from '@/App';

export default function CallFlowDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { currentOrganization } = useOrganization();
  const navigate = useNavigate();

  if (!currentOrganization) {
    return (
      <DashboardLayout activeItem="CallFlows">
        <div className="text-center py-12 text-muted-foreground">
          Please select an organization to view CallFlows
        </div>
      </DashboardLayout>
    );
  }

  if (!id) {
    navigate('/callflows');
    return null;
  }

  return (
    <DashboardLayout activeItem="CallFlows">
      <CallFlowDetail
        callflowId={id}
        organizationId={currentOrganization.id}
        onBack={() => navigate('/callflows')}
      />
    </DashboardLayout>
  );
}
